export default {
    dateTimeFormat: 'DD.MM.YYYY - HH:mm',
    dateTimeFormat2: 'DD MMM YYYY - hh:mm A',
    timeFormat: 'hh:mm A',
    dateFormat: 'DD MMM YYYY',
    dateFormat2: 'YYYY/MM/DD',

    constantSailingScheduleUUIDs: [
        '1234', '12345', '123456', '1234567'
    ],
}
